'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');

/**
 * Slightly modified from: https://www.scottohara.me/blog/2017/04/14/inclusively-hidden.html
 */ const screenReaderOnly = styled.css`
  clip: rect(0 0 0 0) !important;
  clip-path: inset(50%) !important;
  height: 1px !important;
  margin: 0 !important;
  overflow: hidden !important;
  padding: 0 !important;
  position: absolute !important;
  white-space: nowrap !important;
  width: 1px !important;
`;

exports.screenReaderOnly = screenReaderOnly;
//# sourceMappingURL=screen-reader.js.map
